module.exports = __webpack_public_path__ + "img/p60-2013-yuekan.aa5df8b1.jpg";